import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { logEvent } from "firebase/analytics";
// 🔐 Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBgJ8YGGTn156cOaHs0pFdz4HsRE8CNuhA",
  authDomain: "byting-korner.firebaseapp.com",
  projectId: "byting-korner",
  storageBucket: "byting-korner.firebasestorage.app",
  messagingSenderId: "1087162516128",
  appId: "1:1087162516128:web:061943c8dfe908251c7fc5",
  measurementId: "G-WE0C6J0EN3",
};

// ✅ Prevent re-initialization (VERY important in React/Next)
export const firebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// ✅ Analytics (browser-only safe)
export const initAnalytics = async () => {
  if (typeof window !== "undefined" && (await isSupported())) {
    return getAnalytics(firebaseApp);
  }
  return null;
};





let analyticsInstance = null;

export const getAnalyticsInstance = async () => {
  if (!analyticsInstance && typeof window !== "undefined") {
    analyticsInstance = getAnalytics(firebaseApp);
  }
  return analyticsInstance;
};

export const logFirebaseEvent = async (eventName, params = {}) => {
  try {
    const analytics = await getAnalyticsInstance();
    if (!analytics) return;

    logEvent(analytics, eventName, params);
  } catch (err) {
    console.warn("Firebase event log failed:", err);
  }
};
